import script from "./itemMenuMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./itemMenuMobile.vue?vue&type=script&setup=true&lang=js"

import "./itemMenuMobile.vue?vue&type=style&index=0&id=c5e91650&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5e91650"]])

export default __exports__